const paymentMethodsEN = {
    "view": {
        "table": {
            "title": "Your payment methods list",
            "column": {
                "cardholder_name": "Cardholder Name",
                "card_number": "Card Number",
                "expiry_month": "Expiry Month",
                "expiry_year": "Expiry Year",
                "type": "Type",
                "status": "Status",
                "action": "Action"
            },
            "label": {
                "is_default": "Default",
                "is_secondary": "Secondary",
                "is_valid": "Valid",
                "is_expired": "Expired",
                "not_available": "Not Available",
                "month_january": "January",
                "month_february": "February",
                "month_march": "March",
                "month_april": "April",
                "month_may": "May",
                "month_june": "June",
                "month_july": "July",
                "month_august": "August",
                "month_september": "September",
                "month_october": "October",
                "month_november": "November",
                "month_december": "December"
            },
            "dropdown": {
                "action": "Action",
                "edit": "Edit",
                "delete": "Delete"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "You have reached the limit of 3 payment methods, If you want to add a new payment, you can do that by deleting an existing one.",
            "success": "Payment method has been removed!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
        "modal": {
            "delete": {
                "header": "Delete Payment Method {{cardNumber}}",
                "body": "Are you sure that you want to delete this payment method?"
            }
        }
    },
    "add": {
        "title": "Add Payment Method",
        "form": {
            "label": {
                "card_details": "Card Details",
                "cardholder_name": "Cardholder Name",
                "card_number": "Card Number",
                "expiry_month": "Expiry Month",
                "expiry_year": "Expiry Year (YYYY)",
                "security_code_cvc": "Security Code (CVC)",
                "billing_details": "Billing Details",
                "country": "Country",
                "street_and_number": "Street And House Number",
                "city": "City",
                "postal_code": "Postal Code",  
            },
            "help_text": {
               "security_code_cvc": "Your card's security code (CVC) is the 3 or 4 digit number located on the back of most cards.",
            },
            "options": {
                "month": {
                    "january": "January",
                    "february": "February",
                    "march": "March",
                    "april": "April",
                    "may": "May",
                    "june": "June",
                    "july": "July",
                    "august": "August",
                    "september": "September",
                    "october": "October",
                    "november": "November",
                    "december": "December"
                },
                "expiry_month": {
                    "select": "Select Expiry Month"
                },
                "country": {
                    "select": "Select Country"
                }
            },
            "button": {
                "submit": "Submit"
            },
            "validation": {
                "expiry_month_required": "Expiry Month is required",
                "expiry_month_valid": "Expiry Month must not be in past",
                "country_required": "Country is required"
            }
        },
        "message": {
            "success": "Payment method has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Are you sure you would like to add this payment method to your profile?",
                "body": "Hereby you warrant that all given data is truthful. You are solely and legally responsible for the given data and for the truthfulness of such information.",
                "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm"
                }
            }
        }
    },
    "update": {
        "title": "Update Payment Method",
        "form": {
            "label": {
                "card_details": "Card Details",
                "cardholder_name": "Cardholder Name",
                "card_number": "Card Number",
                "expiry_month": "Expiry Month",
                "expiry_year": "Expiry Year (YYYY)",
                "security_code_cvc": "Security Code (CVC)",
                "billing_details": "Billing Details",
                "country": "Country",
                "street_and_number": "Street And House Number",
                "city": "City",
                "postal_code": "Postal Code",  
                "set_as_default": "Set as Default"
            },
            "help_text": {
               "security_code_cvc": "Your card's security code (CVC) is the 3 or 4 digit number located on the back of most cards.",
            },
            "options": {
                "month": {
                    "january": "January",
                    "february": "February",
                    "march": "March",
                    "april": "April",
                    "may": "May",
                    "june": "June",
                    "july": "July",
                    "august": "August",
                    "september": "September",
                    "october": "October",
                    "november": "November",
                    "december": "December"
                },
                "expiry_month": {
                    "select": "Select Expiry Month"
                },
                "country": {
                    "select": "Select Country"
                }
            },
            "button": {
                "submit": "Submit"
            },
            "validation": {
                "expiry_month_required": "Expiry Month is required",
                "expiry_month_valid": "Expiry Month must not be in past",
                "country_required": "Country is required"
            }
        },
        "message": {
            "success": "Payment method has been updated!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Are you sure you would like to update your payment method?",
                "body": "Hereby you warrant that all given data is truthful. You are solely and legally responsible for the given data and for the truthfulness of such information.",
                "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm"
                }
            }
        }
    },
};

export default paymentMethodsEN;